import { Outlet } from 'react-router-dom';
import 'antd/dist/reset.css';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import fr from 'antd/es/date-picker/locale/fr_FR';
import fr_FR from 'antd/es/locale/fr_FR';

import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from './store';
import MaintenancePage from './components/MaintenancePage';
import { useEffect } from 'react';
import { fetchSiteStatus } from './siteSlice';
import { ToastContainer } from 'react-toastify';

function App() {

  const dispatch = useDispatch<AppDispatch>();
const siteEnabled = useSelector((state: RootState) => state.site.siteEnabled);
const loading = useSelector((state: RootState) => state.site.loading);
const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    dispatch(fetchSiteStatus());
  }, [dispatch]);

  if (loading) {
    return null; // ou un loader
  }

  if (!siteEnabled && (user?.role === 'CLIENT')) {
    return <MaintenancePage />;
}



  // console.log("App - siteEnabled:", siteEnabled);
  // console.log("App - user role:", user?.role);



  dayjs.locale('fr');
  // Component level locale
  const frLocale: typeof fr = {
    ...fr,
    lang: {
      ...fr.lang,
    },
  };

// ConfigProvider level locale
const globalFrLocale: typeof fr_FR = {
  ...fr_FR,
  DatePicker: {
    ...fr_FR.DatePicker!,
    lang: frLocale.lang,
  },
};



  return (
    <ConfigProvider locale={globalFrLocale}>
      <ToastContainer />
      <Outlet />
    </ConfigProvider>
  );
}

export default App;
